<template>
  <div>
    <v-row no-gutters v-if="dataUser.IndMantGaleria">
      <v-col class="d-flex child-flex mb-0" cols="12">
        <p class="titulo text-center font-weight-bold">
          Mantenimiento Testimonio
        </p>
      </v-col>
      <v-col
        class="d-flex child-flex"
        cols="12"
        sm="12"
        md="12"
        lg="10"
        xl="10"
      >
        <v-data-table
          :headers="headers"
          :items="Testimonios_items"
          sort-by="calories"
          class="elevation-1"
          :loading="Testimonios_items.length === 0"
        >
          <!--v-slot:[`item.actions`]="{ item }" -->

          <template v-slot:item="{ item }">
            <tr :data-id="item.id">
              <td class="d-print-none">
                <div class="d-flex" flat>
                  <v-card color="transparent" class="mx-auto" flat tile>
                    <v-btn icon @click="editItem(item)">
                      <v-icon color="#002f6c">mdi-pencil</v-icon>
                    </v-btn>
                  </v-card>
                  <v-card color="transparent" class="mx-auto" flat tile>
                    <v-btn icon @click="deleteItem(item)">
                      <v-icon color="red darken-3">mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </div>
              </td>
              <td class="d-print-none">
                <v-checkbox
                  v-model="item.activo"
                  disabled
                  class="pa-3"
                ></v-checkbox>
              </td>

              <td class="d-print-none">{{ item.person_name }}</td>
              <td class="d-print-none">{{ item.testimonio }}</td>
              <td class="d-print-none">
                <v-img
                  contain
                  max-width="90px"
                  :lazy-src="`${imgTestimonios}${item.person_img}?rt=${rT}`"
                  :src="`${imgTestimonios}${item.person_img}?rt=${rT}`"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row> </template
                ></v-img>
              </td>
              <td class="d-print-none">
                <v-img
                  contain
                  max-width="90px"
                  :lazy-src="`${imgTestimonios}${item.empre_img}?rt=${rT}`"
                  :src="`${imgTestimonios}${item.empre_img}?rt=${rT}`"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row> </template
                ></v-img>
              </td>

              <!--  <td class="d-print-none">{{ item.btn_to }}</td> -->
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#002f6c"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Nuevo <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card
                  color="white"
                  light
                  class="mx-auto"
                  :max-width="$vuetify.breakpoint.lgAndUp ? 600 : 480"
                  :width="$vuetify.breakpoint.lgAndUp ? 600 : 480"
                  outlined
                >
                  <v-toolbar color="#002f6c" dark>
                    <v-toolbar-title>
                      <v-img
                        contain
                        :src="`${domoapi2_img}Cia/1/logo?archivo=2.png`"
                        id="Home"
                        width="154"
                      ></v-img>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn
                      icon
                      @click="
                        show = false;
                        dialog = false;
                        status = -1;
                        newurl = null;
                        url = null;
                        url2 = null;
                      "
                      light
                    >
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} </span>
                  </v-card-title>

                  <v-card-text v-if="Object.entries(editedItem).length != 0">
                    <v-container>
                      <v-card class="mx-auto mt-n5">
                        <v-row justify="space-around">
                          <div class="d-flex flex-column">
                            <v-card color="white">
                              <v-avatar tile class="mt-0" size="80">
                                <v-img
                                  contain
                                  :src="
                                    `${imgTestimonios}${editedItem.person_img}?rt=${rT}`
                                  "
                                ></v-img>
                              </v-avatar>
                            </v-card>
                            <v-card color="white">
                              <v-btn
                                small
                                block
                                color="accent"
                                dark
                                width="50"
                              >
                                <v-card-text>
                                  <input
                                    type="file"
                                    @change="onFileChange($event)"
                                    id="file"
                                    ref="file"
                                  />
                                  <span
                                    >{{
                                      editedIndex === -1 ? "Agregar" : "Cambiar"
                                    }}
                                    <v-btn
                                      @click="
                                        submitFileTestimonio();
                                        loading = true;
                                        imgchg = 1;
                                      "
                                      dark
                                      v-if="url"
                                      class="ml-n15"
                                      color="#002f6c"
                                    >
                                      subir
                                      <v-progress-circular
                                        v-if="loading"
                                        :size="20"
                                        color="white"
                                        indeterminate
                                      >
                                      </v-progress-circular>
                                      <v-icon dark v-if="!loading">
                                        mdi-upload
                                      </v-icon></v-btn
                                    ></span
                                  ></v-card-text
                                >
                              </v-btn>
                            </v-card>
                          </div>
                          <div class="d-flex flex-column">
                            <v-card color="white">
                              <v-avatar tile class="mt-0" size="80">
                                <v-img
                                  contain
                                  :src="
                                    `${imgTestimonios}${editedItem.empre_img}?rt=${rT}`
                                  "
                                ></v-img>
                              </v-avatar>
                            </v-card>
                            <v-card color="white">
                              <v-btn
                                small
                                block
                                color="accent"
                                dark
                                width="50"
                              >
                                <v-card-text>
                                  <input
                                    type="file"
                                    @change="onFileChange2($event)"
                                    id="file2"
                                    ref="file2"
                                  />
                                  <span
                                    >{{
                                      editedIndex === -1 ? "Agregar" : "Cambiar"
                                    }}
                                    <v-btn
                                      @click="
                                        submitFileEmpresa();
                                        loading = true;
                                        imgchg = 1;
                                      "
                                      dark
                                      v-if="url2"
                                      class="ml-n15"
                                      color="#002f6c"
                                    >
                                      subir
                                      <v-progress-circular
                                        v-if="loading"
                                        :size="20"
                                        color="white"
                                        indeterminate
                                      >
                                      </v-progress-circular>
                                      <v-icon dark v-if="!loading">
                                        mdi-upload
                                      </v-icon></v-btn
                                    ></span
                                  ></v-card-text
                                >
                              </v-btn>
                            </v-card>
                          </div>
                        </v-row>

                        <div>
                          <v-row no-gutters>
                            <v-col cols="3">
                              <v-switch
                                v-model="editedItem.activo"
                                :label="
                                  `Activo ${editedItem.activo ? 'Si' : 'No'}`
                                "
                              ></v-switch>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="10">
                              <v-text-field
                                placeholder="Placeholder"
                                outlined
                                label="Nombre"
                                v-model="editedItem.person_name"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-textarea
                                  outlined
                                  rows="4"
                                  auto-grow
                                  filled
                                  flat
                                  label="Mensaje"
                                  v-model="editedItem.testimonio"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-row>
                        </div>
                      </v-card>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-alert
                      v-if="status != -1"
                      v-model="alert"
                      dismissible
                      color="#002f6c"
                      dense
                      border="left"
                      elevation="2"
                      class="ma-1"
                      outlined
                      colored-border
                      icon="mdi-alert"
                    >
                      <strong>{{ msg }}</strong>
                    </v-alert>
                    <!--
                      <v-alert
                      v-if="status != -1"
                      text
                      dense
                      class="ml-3"
                      color="#002f6c"
                      icon="mdi-alert"
                      border="left"
                      outlined
                    >
                      <span class="body-2 font-weight-bold text-center">
                        {{ msg }}
                      </span>
                    </v-alert>
                    -->
                    <v-spacer></v-spacer>

                    <v-btn
                      color="#002f6c"
                      dark
                      @click="
                        editedIndex > -1
                          ? (editTestimonio(), (loading = true))
                          : addTestimonio()
                      "
                    >
                      Guardar
                      <v-progress-circular
                        v-if="loading"
                        :size="20"
                        color="white"
                        indeterminate
                      >
                      </v-progress-circular>
                      <v-icon dark v-if="!loading"> mdi-content-save</v-icon>
                    </v-btn>

                    <v-btn
                      color="#B71C1C"
                      dark
                      @click="
                        show = false;
                        dialog = false;
                        status = -1;
                        newurl = null;
                        url = null;
                        url2 = null;
                      "
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" persistent max-width="380">
                <v-card class="elevation-12" color="#002f6c" dark>
                  <v-toolbar dark flat width="380" color="white">
                    <v-toolbar-title>
                      <v-img
                        contain
                        :src="`${domoapi2_img}Cia/1/logo?archivo=1.png`"
                        id="Home"
                        width="154"
                      ></v-img>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-center">
                    <v-card-subtitle class="headline">
                      Seguro que desea Eliminar?
                    </v-card-subtitle>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn plain dark color="white" @click="closeDelete"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="accent"
                      @click="
                        deleteTestimonio()
                        deleteItemConfirm
                      "
                    >
                      OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      show: false,
      imgchg: 0,
      alert: false,
      msg: "",
      status: -1,
      newurl: null,
      file: "",
      url: "",
      file2: "",
      url2: "",
      loading: false,
      menu: false,
      menuh: false,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "Tarea",
          class: "body-2 font-weight-bold",
          value: "actions",
          width: "60px",
          sortable: false,
        },
        {
          text: "Activo",
          divider: true,
          class: "body-2 font-weight-bold",
          width: "60px",
          value: "activo",
          sortable: false,
        },
        {
          text: "Nombre",
          class: "body-2 font-weight-bold",
          width: "150px",
          divider: true,
          value: "person_name",
          sortable: false,
        },
        {
          text: "Testimonio",
          align: "start",
          class: "body-2 font-weight-bold",
          width: "150px",
          sortable: false,
          value: "testimonio",
        },
        {
          text: "Imagen",
          divider: true,
          value: "person_img",
          class: "body-2 font-weight-bold",
          width: "100px",
          sortable: false,
        },
        {
          text: "Logo",
          divider: true,
          value: "empre_img",
          class: "body-2 font-weight-bold",
          width: "100px",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        id: "",
        person_img: "",
        person_name: "",
        activo: false,
        testimonio: "",
        empre_img: "",
      },
      defaultItem: {
        id: "",
        person_img: "",
        person_name: "",
        activo: false,
        testimonio: "",
        empre_img: "",
      },
    };
  },
  computed: {
    ...mapState([
      "imgPeque",
      "timeLog",
      "Carousel_items",
      "Testimonios_items",
      "dirPHP",
      "imgCarousel",
      "imgTestimonios",
      "imgCat",
      "SubCategorias",
      "dataUser",
      "mnuCategorias",
      "ErrorBuscarA",
      "BuscarOverlayA",
      "NoImg",
      "domoapi2_img"
    ]),

    numId() {
      return this.Testimonios_items.length;
    },
    rT() {
      return Math.random();
    },

    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Item Testimonio"
        : "Editar Item Testimonio ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
    this.clr_Testimonios_items();
  },

  methods: {
    ...mapActions([
      "cargarLog"]),
    ...mapMutations([
      "set_dataLog",
      "set_Testimonios_items", 
      "clr_Testimonios_items"]),
       async logAdd(uri, action){
      
    const xdatoslog = `${this.timeLog} | ${uri} | ${action} | ${this.dataUser.Usuario}`
    this.set_dataLog(xdatoslog)
    await this.cargarLog()
    },
    async addTestimonio() {
      let that = this;
      this.editedItem.id = this.numId;

      const URL = `${this.dirPHP}add_testimonio.php`;
      await this.axios
        .post(URL, this.editedItem, {
          headers: { "Content-Type": "application/json" },
          params: {
            cod: this.numId,
          },
        })
        .then(function(response) {
          that.status = response.data.estatus;
          that.msg = response.data.message;
          that.alert = true;
          //refrescar
           that.$nextTick(function() {
            that.logAdd(`${URL}`,  `INSERT TESTIMONIO` );
            that.initialize(); 
            that.clr_Testimonios_items();
           
          });
         // that.Testimonios_items.push(that.editedItem);
          console.log(response.data);
        })
        .catch(function() {
          console.log("Error al Editar!!");
        })
        .finally(() => (that.loading = false));
    },
    async editTestimonio() {
      let that = this;

      const URL = `${this.dirPHP}edit_testimonio.php`;
      await this.axios
        .post(URL, this.editedItem, {
          headers: { "Content-Type": "application/json" },

          params: {
            cod: this.editedItem.id,
          },
        })
        .then(function(response) {
          that.status = response.data.estatus;
          that.msg = response.data.message;
          that.alert = true;
         
   that.$nextTick(function() {
            that.logAdd(`${URL}`,  `EDIT TESTIMONIO: ${that.editedItem.id}` );
            that.initialize(); 
            that.clr_Testimonios_items();
          });
         /* Object.assign(
            that.Testimonios_items[that.editedIndex],
            that.editedItem
          );*/
          console.log(response.data);
        })
        .catch(function() {
          console.log("Error al Editar!!");
        })
        .finally(() => (that.loading = false));
    },
    async deleteTestimonio() {
      let that = this;
      console.log(this.editedItem);
      const URL = `${this.dirPHP}delete_testimonio.php`;
      await this.axios
        .post(URL, this.editedItem, {
          headers: { "Content-Type": "application/json" },

          params: {
            cod: this.editedItem.id,
          },
        })
        .then(function(response) {
          that.status = response.data.estatus;
          that.msg = response.data.message;
          that.alert = false;
            that.$nextTick(function() {
            that.logAdd(`${URL}`,  `DELETE TESTIMONIO: ${that.editedItem.id}` );
            that.initialize(); 
            that.clr_Testimonios_items();
          });
        //  that.Testimonios_items.splice(that.editedIndex, 1);
          that.closeDelete();

          console.log(response.data);
        })
        .catch(function() {
          console.log("Error al Editar!!");
        })
        .finally(() => (that.loading = false));
    },
    async submitFileEmpresa() {
      let formData = new FormData();
      let that = this;
      formData.append("file2", this.file2);
      const URL = `${this.dirPHP}upload_empresa.php`;
      await this.axios
        .post(URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            cod: this.editedIndex === -1 ? this.numId : this.editedItem.id,
          },
        })
        .then(function(response) {
          that.status = response.data.estatus;
          that.msg = response.data.message;
          that.url2 = "";
          that.file2 = "";
          that.newurl = response.data.newurl;
          //editedItem.img_src
          that.editedItem.empre_img = that.newurl;
          that.imgchg = 0;
          that.alert = true;
            that.logAdd(`${URL}`,  `UOLOAD EMPRESA: ${that.editedIndex === -1 ? that.numId : that.editedItem.id}` );
        })
        .catch(function() {
          console.log("Error al Subir !!");
        })
        .finally(() => (that.loading = false));
    },
    async submitFileTestimonio() {
      let formData = new FormData();
      let that = this;
      formData.append("file", this.file);
      const URL = `${this.dirPHP}upload_testimonio.php`;
      await this.axios
        .post(URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            cod: this.editedIndex === -1 ? this.numId : this.editedItem.id,
          },
        })
        .then(function(response) {
          that.status = response.data.estatus;
          that.msg = response.data.message;
          that.url = "";
          that.file = "";
          that.newurl = response.data.newurl;
          //editedItem.img_src
          that.editedItem.person_img = that.newurl;
          that.imgchg = 0;
          that.alert = true;
           that.logAdd(`${URL}`,  `UOLOAD TESTIMONIO: ${that.editedIndex === -1 ? that.numId : that.editedItem.id}` );
        })
        .catch(function() {
          console.log("Error al Subir !!");
        })
        .finally(() => (that.loading = false));
    },
    onFileChange2(e) {
      //const file = e.target.files[0];

      const selectFile = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(selectFile);
      reader.addEventListener(
        "load",
        () => {
          this.url2 = reader.result;
          this.file2 = this.$refs.file2.files[0];
        },
        false
      );
    },
    onFileChange(e) {
      //const file = e.target.files[0];

      const selectFile = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(selectFile);
      reader.addEventListener(
        "load",
        () => {
          this.url = reader.result;
          this.file = this.$refs.file.files[0];
          // console.log('select image', reader.result)
        },
        false
      );
    },
    async initialize() {
      let that = this;
      const URL = `${this.dirPHP}leertestimonio.php`;
      await this.axios
        .get(URL, {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        })
        .then(function(response) {
          response.data.forEach(function(data, index) {
            that.set_Testimonios_items(data);
          });
        });
    },

    async editItem(item) {
      this.editedIndex = await this.Testimonios_items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      this.editedIndex = await this.Testimonios_items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.Testimonios_items.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.Testimonios_items[this.editedIndex],
          this.editedItem
        );
      } else {
        this.Testimonios_items.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
